import React from 'react';
import { Link } from 'react-scroll';
import Drawer from '@material-ui/core/Drawer';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import './styles.scss';

interface ILink {
  title: string;
  to: string;
}

interface IProps {
  open: boolean;
  toggleDrawer: (open: boolean) => (event: any) => void;
  links?: ILink[];
}

const PearDrawer = ({ open, toggleDrawer, links = [] }: IProps) => {
  const isSmallerThanMaxWidth = useMediaQuery('(max-width:767px)');
  const displayValue = isSmallerThanMaxWidth ? 'block' : 'none';

  return (
    <div style={{ display: displayValue }}>
      <button type="button" onClick={toggleDrawer(true)} styleName="action-btn">
        Show Table of Contents
      </button>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        <div
          styleName="wrapper"
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <button
            type="button"
            onClick={toggleDrawer(false)}
            styleName="action-btn"
          >
            &#60; Hide Table of Contents
          </button>
          <ul styleName="list">
            {links.map((item: ILink) => {
              return (
                <li key={item.title}>
                  <Link
                    to={item.to}
                    spy
                    smooth
                    duration={500}
                    delay={200}
                    title={`Jump to: ${item.title}`}
                    // @ts-ignore
                    onClick={toggleDrawer(false)}
                  >
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </Drawer>
    </div>
  );
};

export default PearDrawer;
